module.exports = __webpack_public_path__ + "img/icon-18.8ca497a8.svg";